// Feature: M004-F0714. Tests: T-M004-0208, T-M004-0209.
//
// "Find a transaction" (design M004-F0712-F0716 section 3): ONE org-scoped component. It normalises the input
// (parseTxInput), refuses a bad one BEFORE any request, and hands a good one to the shared history drawer, where every
// outcome (found, 404, 403, 409 candidates, 400) is rendered. It never filters a list, never probes another organisation.
import React, { useState } from 'react';
import { parseTxInput } from '../utils/transactionId';
import { useTxHistory } from './txHistoryContext';
import './TxFinder.css';

export const TX_BAD_INPUT = 'That is not a transaction number. Use TXN- followed by its code, for example TXN-0018-5JHWEU1ES8X, or the full id.';

export default function TxFinder({ orgId, customerUserId, label = 'Find a transaction' }) {
  const history = useTxHistory();
  const [value, setValue] = useState('');
  const [invalid, setInvalid] = useState(false);
  if (!history || orgId == null || orgId === '') return null;
  const busy = history.busy === true;
  const submit = (event) => {
    event.preventDefault();
    if (busy) return;
    const parsed = parseTxInput(value);
    if (!parsed.ok) { setInvalid(true); return; }
    setInvalid(false);
    history.openTransaction({ key: parsed.key, orgId, customerUserId, handOffId: parsed.kind === 'full' ? parsed.key : '' });
  };
  return (
    <form className="tx-finder" role="search" aria-label="Transaction finder" onSubmit={submit} data-testid="tx-finder">
      <label htmlFor="tx-finder-input">{label}</label>
      <input
        id="tx-finder-input"
        type="text"
        autoComplete="off"
        spellCheck="false"
        placeholder="TXN-0018-5JHWEU1ES8X"
        value={value}
        aria-invalid={invalid ? 'true' : undefined}
        aria-describedby={invalid ? 'tx-finder-error' : undefined}
        onChange={(event) => { setValue(event.target.value); if (invalid) setInvalid(false); }}
      />
      <button type="submit" className="btn btn-outline" disabled={busy}>Find</button>
      {invalid ? <p id="tx-finder-error" className="tx-finder-error" role="alert" data-testid="tx-finder-error">{TX_BAD_INPUT}</p> : null}
    </form>
  );
}
